import React, { useState } from 'react';
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { Property, PropertyInvoiceWithRelations } from '../../redux/residentPortalApi';
import WalletCard from '../common/WalletCard';
import TopUpModal from '../common/TopUpModal';
import PadelCourtInvoicesList from './PadelCourtInvoicesList';

interface OwnProps {
  property: Property;
  invoices: PropertyInvoiceWithRelations[] | undefined;
  outstandingPadelBalance: number | null;
}

const PadelCourtInvoicesSection: React.FC<OwnProps> = ({
  property,
  invoices,
  outstandingPadelBalance,
}) => {
  const [openTopUpDialog, setOpenTopUpDialog] = useState(false);

  const handleOpenDialog = () => setOpenTopUpDialog(true);
  const handleCloseDialog = () => setOpenTopUpDialog(false);

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        borderRadius: 2,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        mb: 4,
      }}
    >
      <Stack spacing={3}>
        <Typography
          variant="h2"
          sx={{
            fontSize: '1.75rem',
            fontWeight: 600,
            color: '#1976d2',
            mb: 2,
            borderBottom: '2px solid #e0e0e0',
            paddingBottom: 1,
          }}
        >
          Padel Court Invoices
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <WalletCard
              purpose="pedalCourtInvoiceBalance"
              property={property}
              outstandingLeviesBalance={outstandingPadelBalance}
              handleOpenDialog={handleOpenDialog}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            {invoices ? (
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                  overflow: 'hidden',
                }}
              >
                <PadelCourtInvoicesList property={property} invoices={invoices} />
              </Card>
            ) : (
              <Box>
                <Skeleton variant="rectangular" height={40} width="100%" animation="wave" />
                <Skeleton
                  variant="rectangular"
                  height={40}
                  width="100%"
                  animation="wave"
                  style={{ marginTop: 10 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={40}
                  width="100%"
                  animation="wave"
                  style={{ marginTop: 10 }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Stack>

      <Dialog open={openTopUpDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogContent>
          <TopUpModal purpose="pedalCourtInvoiceBalance" propertyId={property.id ?? ''} />
        </DialogContent>
      </Dialog>
    </Paper>
  );
};

export default PadelCourtInvoicesSection;
